import { render } from "./hero.vue?vue&type=template&id=2e4e6e15&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=2e4e6e15&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2e4e6e15"

export default script